export default __webpack_public_path__ + "static/media/Mantine-Logo.e43c032a.svg";